import React from 'react';
import * as Styled from './styled';
import { SectionTitle } from 'screens/DeveloperPage/styled';
import { useLocale } from 'locale';
import WebsiteIcon from 'assets/svg/developer/website.svg';
import FacebookIcon from 'assets/svg/developer/facebook.svg';
import LinkedinIcon from 'assets/svg/developer/linkedin.svg';
import InstagramIcon from 'assets/svg/developer/instagram.svg';
import { LinkInner } from './styled';
import withEvents from 'analytics/withEvents';
import { IDeveloperProfile } from 'utils/entities';
import AnchorMiddleware from 'components/anchor';


enum LinkType {
  Website = 'official_website',
  Linkedin = 'linkedin',
  Facebook = 'facebook',
  Instagram = 'instagram',
}

const linkTypeToIcon = {
  [LinkType.Website]: <WebsiteIcon />,
  [LinkType.Linkedin]: <LinkedinIcon />,
  [LinkType.Facebook]: <FacebookIcon />,
  [LinkType.Instagram]: <InstagramIcon />,
};
interface DeveloperLinksProps {
  developer: Pick<IDeveloperProfile, 'id' | 'name' | 'integrationLevel'>;
  website: string;
  linkedIn: string;
  facebook: string;
  instagram: string;
  onExternalLinkClick?: (type: LinkType) => void;
}

const DeveloperLink: React.FC<{ link: string; type: LinkType; onClick: (type: LinkType) => void }> = ({
  link, type, onClick,
}) => (
  <AnchorMiddleware href={link}>
    {(href) => (
      <a href={href} target="_blank" rel="nofollow" onClick={() => onClick(type)}>
        <LinkInner>
          {linkTypeToIcon[type]}
        </LinkInner>
      </a>
    )}
  </AnchorMiddleware>
);

const DeveloperLinks: React.FC<DeveloperLinksProps> = (props) => {
  const { t } = useLocale();
  const { website, linkedIn, facebook, instagram, onExternalLinkClick } = props;

  if (!website && !linkedIn && !facebook && !instagram) return null;

  return (
    <Styled.Wrapper>
      <SectionTitle>{t('developerPage.links.title')}</SectionTitle>
      <Styled.LinksWrapper>
        {website ? <DeveloperLink link={website} type={LinkType.Website} onClick={onExternalLinkClick}/> : null}
        {facebook ? <DeveloperLink link={facebook} type={LinkType.Facebook} onClick={onExternalLinkClick}/> : null}
        {linkedIn ? <DeveloperLink link={linkedIn} type={LinkType.Linkedin} onClick={onExternalLinkClick}/> : null}
        {instagram ? <DeveloperLink link={instagram} type={LinkType.Instagram} onClick={onExternalLinkClick}/> : null}
      </Styled.LinksWrapper>
    </Styled.Wrapper>
  );
};

export default React.memo(withEvents<DeveloperLinksProps>((sendEvent, { developer }) => ({
  onExternalLinkClick(type: LinkType) {
    sendEvent('developer_external_link_click', 'developer', {
      event: {
        external_link_type: type,
      },
      developer: {
        id: developer.id,
        integration_level: developer.integrationLevel.toLowerCase(),
        name: developer.name,
      },
    });
  },
}))(DeveloperLinks));
